export type DialogResult =
  | {
      success: boolean;
    }
  | undefined; // because if you click outside, there is a return of undefined
